import React, { FC, ReactNode } from 'react'
import { Badge, Flex, Tooltip, Typography } from 'antd'
import { CaretUpFilled, CaretDownFilled } from '@ant-design/icons'
import { Well } from '@pushly/aqe/lib/components'
import { WellItemActions } from '../../../../../../components/data-control-row/layout-row-with-actions'
import './vespa-configuration-card.scss'

type VespaConfigurationCardProps = {
    recordId: string
    ordinal: number
    label: string
    summary?: string
    readonly: boolean
    isFirst: boolean
    isLast: boolean
    onShift: (direction: 1 | -1) => void
    onCopy: () => void
    onDelete: () => void
    children: ReactNode
}

export const VespaConfigurationCard: FC<VespaConfigurationCardProps> = ({
    recordId,
    ordinal,
    label,
    summary,
    readonly,
    isFirst,
    isLast,
    onShift,
    onCopy,
    onDelete,
    children,
}) => {
    return (
        <div className="vespa-config-card" id={recordId}>
            <Well
                collapsible
                title={
                    <Flex align="center" gap="var(--space-2)">
                        <Badge count={ordinal} color="var(--color-secondary-100)" />
                        <Typography.Text>{label}</Typography.Text>
                        {summary && (
                            <Typography.Text
                                className="vespa-config-card__collapsed-summary"
                                ellipsis={{ tooltip: summary }}
                            >
                                {summary}
                            </Typography.Text>
                        )}
                    </Flex>
                }
                actions={
                    <Flex className="vespa-config-card__actions" gap="var(--space-2)">
                        {!readonly && (
                            <span className="vespa-config-card__reorder">
                                <Tooltip title="Move up">
                                    <button
                                        type="button"
                                        className="vespa-config-card__shift"
                                        aria-label="Move configuration up"
                                        disabled={isFirst}
                                        onClick={() => onShift(-1)}
                                    >
                                        <CaretUpFilled aria-hidden="true" />
                                    </button>
                                </Tooltip>
                                <Tooltip title="Move down">
                                    <button
                                        type="button"
                                        className="vespa-config-card__shift"
                                        aria-label="Move configuration down"
                                        disabled={isLast}
                                        onClick={() => onShift(1)}
                                    >
                                        <CaretDownFilled aria-hidden="true" />
                                    </button>
                                </Tooltip>
                            </span>
                        )}
                        <WellItemActions
                            readonly={readonly}
                            dataItem={<span>Configuration</span>}
                            onCopy={onCopy}
                            onDelete={onDelete}
                        />
                    </Flex>
                }
            >
                {children}
            </Well>
        </div>
    )
}
